import { PanelLeft, Search } from "lucide-react";
import WindowButtons from "../common/WindowButtons";
import Dropdown, { DropdownContent, DropdownTrigger } from "../common/Dropdown";
import { useState } from "react";
import type Project from "@/types/project";
import ProjectSearchPanel from "./ProjectSearchPanel";

type HeaderIdeProps = {
    projects: Project[];
    onProjectSelect: (projectId: string) => void;
    toggleExplorer: () => void;
};

export default function HeaderIde({ projects, onProjectSelect, toggleExplorer }: HeaderIdeProps) {
    const [searchDropdownOpen, setSearchDropdownOpen] = useState(false);

    return (
        <div className="h-7 w-full border-b border-white/15 flex items-center justify-between p-1.5">
            <WindowButtons />
            <Dropdown
                placement="bottom-center"
                open={searchDropdownOpen}
                onOpenChange={setSearchDropdownOpen}
                role="listbox"
                ariaLabel="Recherche de projets"
            >
                <DropdownTrigger asChild>
                    <button className="h-5 flex items-center justify-center gap-3 hover:bg-white/5 rounded-md px-2 py-1 cursor-pointer">
                        <Search className="size-3.5 text-white/70" />
                        <p className="text-[11px] font-mono text-white/70">Rechercher un projet</p>
                    </button>
                </DropdownTrigger>
                <DropdownContent className="w-screen md:w-[min(90vw,720px)] h-[calc(100vh-108px)] md:h-auto rounded-b-xl md:rounded-xl border border-white/15 bg-[#050505] p-4 shadow-2xl backdrop-blur">
                    <ProjectSearchPanel
                        projects={projects}
                        onProjectSelect={onProjectSelect}
                        setSearchDropdownOpen={setSearchDropdownOpen}
                    />
                </DropdownContent>
            </Dropdown>
            <div className="w-20 flex items-center justify-end">
                <button className="h-5 hidden lg:flex items-center justify-center gap-3 hover:bg-white/5 rounded-md p-1 cursor-pointer aspect-square" onClick={toggleExplorer}>
                    <PanelLeft className="size-3.5 text-white/70" />
                </button>
            </div>
        </div>
    )
}
